import React from "react";
import {styled} from "@material-ui/core/styles";
import Utils from "../addContact/Utils";
import { AGENCY_BUSINESS_TYPE } from "../../helpers/CoreConstant";
import PermissionUtils from "../../helpers/PermissionUtils";

const PublicLayoutWrapper = styled("div")({
    height: "100vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
        width: "10px",
    },
    "&::-webkit-scrollbar-track": {
        borderRadius: "10px",
        backgroundColor: "#2c3e50",
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "var(--purple)",
        borderRadius: "10px",
    },
});

export const PublicLayout = ({ children }) => {
    window.hasPermission = (module, permission) => {
        try {
            if (Utils.getAccountData("agencyBusinessType") === AGENCY_BUSINESS_TYPE.INSURANCE || Utils.getAccountData("hasGlobalFeature")) {
                const permissionValue = Utils.getAccountData('permissionValue');
                if (!permissionValue) return false;

                return PermissionUtils.hasPermission(PermissionUtils.toBigInt(permissionValue), module, permission);
            }

            return Utils.getAccountData('userIsOwner');
        } catch (err) {
            console.error("hasPermission error:", err);
            return false;
        }
    };
  return (
      <PublicLayoutWrapper className="public_page_container">
        {children}
      </PublicLayoutWrapper>
  );
}